import { render } from "./StripeCards.vue?vue&type=template&id=4c33233f"
import script from "./StripeCards.vue?vue&type=script&lang=js"
export * from "./StripeCards.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__